export const iconFontAwesomeWeatherCloudSun = (
	<i className="fa-solid fa-cloud-sun"></i>
);
